export default "__VITE_ASSET__BU6gr3OA__"